import React, { useState, useEffect } from 'react';
import EventSystem from './EventSystem';
import { Grid, Row } from 'react-bootstrap';
import { Textfit } from 'react-textfit';
import './css/micsModule.css';

export default function MicsDisplayModule({ parameters, onSendMessage }) {
    const [micsVisible, setMicsVisible] = useState(true);

    useEffect(() => {
        onSendMessage({
            sourceModuleName: parameters.config.module_name,
            event_grouping_seq: parameters.config.event_grouping_seq,
            customerID: parameters.userProfile.customer_id,
            siteID: parameters.userProfile.site_id,
            eventID: parameters.config.event_id,
        });

        function showMessage(data) {
            setMicsVisible(data.micsVisible);
        }

        EventSystem.subscribe('MicsControlModule', showMessage);
        EventSystem.subscribe('MicsDisplayModule', showMessage);
        return () => {
            EventSystem.unsubscribe('MicsControlModule', showMessage);
            EventSystem.unsubscribe('MicsDisplayModule', showMessage);
        };
    }, []);

    const containerH = parameters.containerHeight.container;
    const rowStyle = { height: containerH + 'px', lineHeight: containerH + 'px', marginLeft: 0, marginRight: 0, width: '100%' };
    const divStyle = { display: micsVisible ? 'block' : 'none', whiteSpace: 'nowrap', width: '100%' };
    const message = parameters.config.description.length === 0 ? 'Mics On' : parameters.config.description;

    return (
        <div>
            <Grid fluid={true} style={{ paddingLeft: 0, paddingRight: 0 }}>
                <Row style={rowStyle}>
                    <div style={divStyle} className="micsModule-micAlert">
                        <Textfit mode="single" forceSingleModeWidth={false}>
                            {message}
                        </Textfit>
                    </div>
                </Row>
            </Grid>
        </div>
    );
}
